import { render, staticRenderFns } from "./search-resource-input.vue?vue&type=template&id=0036a1f0"
import script from "./search-resource-input.vue?vue&type=script&lang=js"
export * from "./search-resource-input.vue?vue&type=script&lang=js"
import style0 from "./search-resource-input.vue?vue&type=style&index=0&id=0036a1f0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports